import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { TransactionStatus } from '../service-proxies';


export class OverTimeApplicationDto implements IOverTimeApplicationDto {
    id!: number;
    employee!: EmployeeSummaryDto;
    otDate!: Date;
    otHours!: number;
    approver!: EmployeeSummaryDto;
    approveHrs!: number;
    overtimeStatus!: TransactionStatus;
    overtimeStatusType!: string | undefined;
    otRemark!: string | undefined;
    thumbInTime!: Date | undefined;
    thumbOutTime!: Date | undefined;
    presentTime!: string | undefined;

    constructor(data?: IOverTimeApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.otDate = _data["otDate"] ? new Date(_data["otDate"].toString()) : <any>undefined;
            this.otHours = _data["otHours"];
            this.approver = _data["approver"] ? EmployeeSummaryDto.fromJS(_data["approver"]) : <any>undefined;
            this.approveHrs = _data["approveHrs"];
            this.overtimeStatus = _data["overtimeStatus"];
            this.overtimeStatusType = _data["overtimeStatusType"];
            this.otRemark = _data["otRemark"];
            this.thumbInTime = _data["thumbInTime"] ? new Date(_data["thumbInTime"].toString()) : <any>undefined;
            this.thumbOutTime = _data["thumbOutTime"] ? new Date(_data["thumbOutTime"].toString()) : <any>undefined;
            this.presentTime = _data["presentTime"];
        }
    }

    static fromJS(data: any): OverTimeApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverTimeApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["otDate"] = this.otDate ? this.otDate.toISOString() : <any>undefined;
        data["otHours"] = this.otHours;
        data["approver"] = this.approver ? this.approver.toJSON() : <any>undefined;
        data["approveHrs"] = this.approveHrs;
        data["overtimeStatus"] = this.overtimeStatus;
        data["overtimeStatusType"] = this.overtimeStatusType;
        data["otRemark"] = this.otRemark;
        data["thumbInTime"] = this.thumbInTime ? this.thumbInTime.toISOString() : <any>undefined;
        data["thumbOutTime"] = this.thumbOutTime ? this.thumbOutTime.toISOString() : <any>undefined;
        data["presentTime"] = this.presentTime;
        return data; 
    }
}

export interface IOverTimeApplicationDto {
    id: number;
    employee: EmployeeSummaryDto;
    otDate: Date;
    otHours: number;
    approver: EmployeeSummaryDto;
    approveHrs: number;
    overtimeStatus: TransactionStatus;
    overtimeStatusType: string | undefined;
    otRemark: string | undefined;
    thumbInTime: Date | undefined;
    thumbOutTime: Date | undefined;
    presentTime: string | undefined;
}

